import { addTranslations } from "../../../translations/language-provider/translations";
// todo - remove everything that comes from outside the lib folder(manage somehow)

const messages = {
  contentManagement: "Gestão de Conteúdos",
  customTexts: "Textos Personalizados",
  emailTemplates: "Modelos de Email",
  pacients: "Pacientes",
  prescribers: "Prescritores",
  companies: "Empresas",
  questionnairesMenu: "Questionários",
  questionsMenu: "Perguntas",
  usersMenu: "Utilizadores",
  otherMenu: "Outros",
  answerOptions: "Opções de Resposta",
  dataBase: "Base de Dados",
  answersMenu: "Opções de Resposta",
  answerQuestionnaireMenu: "Responder Questionário",
  new: "Novo",
  criteriaMenu: "Critérios",
  criteriaUsageMenu: "Uso de Critérios",
  metaSkillMenu: "Meta Habilidades",
  principleMenu: "Princípios",
  algorithmMenu: "Algoritmo Principal",
  invitesMenu: "Convites",
  elementMenu: "Elementos",
  feelingsMenu: "Sentimentos",
  organsMenu: "Órgãos",
  outputMenu: "Outputs",
  attributesMenu: "Atributos",
  inputMenu: "Inputs",
  secondaryAlgorithmMenu: "Algoritmo Secundário",
  naturalElementMenu: "Elementos Naturais",
  seasonMenu: "Estações",
  characterMenu: "Caracteres",
  answerComponentMenu: "Componentes",
  mobileApkMenu: "Aplicações Móveis",
  criteriaManagementMenu: "Gestão de Critérios",
  apkMenu: "APK",
  textConfigMenu: "Configuração de Texto",
  algorithmOutputMenu: "Outputs de Algoritmo",
  generalOutputMenu: "Outputs Gerais",
  highlightMenu: "Destaques",
  highlightTypeMenu: "Tipos de Destaque",
  highlightOutputMenu: "Outputs",
  dailyChallengeMenu: "Desafio Diário",
  staticStringMenu: "Strings Estáticas",
  userBackofficeMenu: "Utilizadores de Backoffice",
  companyUsersMenu: "Utilizadores de empresa",
  userAppMenu: "Utilizadores de APP",
  analysis: "Análises",
  editableValues: "Valores editáveis",
  settingsMenu: "Definições",
  configurationMenu: "Configuração",
  advancedMenu: "Avançado",
  welcome: "Bem-vindo",
  welcome_back_name: "Bem-vindo de volta, {name}",
  welcome_subtitle:
    "Aqui está uma visão rápida dos últimos 30 dias e atalhos para tarefas comuns.",
  metrics_last_30_days: "Últimos 30 dias",
  analyses: "Análises",
  completed_of: "{completed} concluídas de {total}",
  invitations_sent: "Convites enviados",
  reports_sent: "Relatórios enviados",
  new_patients: "Novos pacientes",
  new_prescribers: "Novos prescritores",
  quick_access: "Acesso rápido",
  reports: "Relatórios",
  search_placeholder: "Pesquisar pacientes, análises, páginas…",
  search_pages: "Páginas",
  search_patients: "Pacientes",
  search_prescribers: "Prescritores",
  search_analyses: "Análises",
  search_invitations: "Convites",
  search_no_results: "Nenhum resultado encontrado",
  page_desc_welcome: "Visão geral e métricas-chave dos últimos 30 dias",
  page_desc_history: "Ver e gerir as análises recentes e o seu estado",
  page_desc_questionnaire:
    "Iniciar uma análise, criar convites ou pré-pagar um questionário",
  page_desc_invites: "Consultar convites e reenviar emails",
  page_desc_pacients: "Ver e gerir contas de pacientes",
  page_desc_prescribers: "Ver e gerir contas de prescritores",
  page_desc_companies: "Ver e gerir empresas, taxas da plataforma e estado Stripe",
  page_desc_users_backoffice:
    "Gerir administradores e consultores com acesso ao backoffice",
  page_desc_users_app: "Gerir utilizadores com acesso à app móvel",
  page_desc_reports: "Editar conteúdo, textos e opções dos relatórios",
  page_desc_email_templates: "Gerir modelos de conteúdo de email",
  page_desc_custom_texts: "Gerir textos personalizados do sistema",
  page_desc_push_notifications: "Gerir conteúdo das push notifications",
  page_desc_settings: "Configurar constantes e valores editáveis do sistema",
  page_desc_questionnaires: "Criar e gerir questionários",
  page_desc_questions: "Criar e gerir perguntas",
  page_desc_answer_options: "Criar e gerir opções de resposta",
  page_desc_gallery: "Consultar e carregar imagens da galeria",
  page_desc_criteria: "Gerir critérios do algoritmo",
  page_desc_criteria_usage: "Gerir a utilização de critérios no algoritmo",
  page_desc_meta_skill: "Gerir meta habilidades",
  page_desc_principle: "Gerir princípios",
  page_desc_algorithm_config: "Configurar definições do algoritmo",
  page_desc_element: "Gerir elementos do algoritmo",
  page_desc_feeling: "Gerir atributos de sentimentos",
  page_desc_organ: "Gerir atributos de órgãos",
  page_desc_season: "Gerir atributos de estações",
  page_desc_natural_element: "Gerir atributos de elementos naturais",
  page_desc_character: "Gerir atributos de caracteres",
  page_desc_input: "Gerir inputs do algoritmo",
  page_desc_algorithm_output: "Gerir outputs do algoritmo",
  page_desc_general_output: "Gerir outputs gerais",
  page_desc_mobile_apps: "Gerir aplicações móveis",
  page_desc_criteria_management: "Gerir definições de gestão de critérios",
  prescriber_dashboard: "O meu Painel de Prescritor",
  page_desc_prescriber_dashboard:
    "Prescrever análises e acompanhar os seus próprios convites, como no backoffice",
};

addTranslations("pt-PT", messages);

export default messages;
